import { createContext, useContext } from 'react'
import type { AuthDisplayContextType } from './types'

export const AuthDisplayContext = createContext<AuthDisplayContextType | null>(null)

export const useAuthDisplayContext = (): AuthDisplayContextType => {
  const context = useContext(AuthDisplayContext)
  if (!context) {
    throw new Error(
      'useAuthDisplayContext must be used within an AuthProvider. Make sure your component is wrapped with AuthProvider.'
    )
  }
  return context
}
